import styled from "styled-components";

export const ButtonBase = styled.button`
  border: 1px solid #e7e7e7;
  border-radius: 10px;
  font-size: 14px;
  padding: 7px 15px;
  outline: none;
  display: block;
  border: none;
`;
